export default "__VITE_ASSET__CwIYfQp$__"